
const certifications = [
  {
    icon: 'ri-medal-line',
    code: 'ISO 9001',
    title: '품질경영시스템',
    description: '고객 만족을 위한 품질 보증 시스템 구축으로 제품과 서비스의 일관된 품질을 보장합니다.',
    shortDesc: '품질 보증 시스템으로 일관된 품질 보장',
    benefits: ['고객 신뢰도 향상', '품질 비용 절감', '프로세스 효율화']
  },
  {
    icon: 'ri-leaf-line',
    code: 'ISO 14001',
    title: '환경경영시스템',
    description: '친환경 경영 체계 및 환경 규제 대응으로 지속 가능한 경영을 실현합니다.',
    shortDesc: '친환경 경영으로 지속 가능한 성장',
    benefits: ['환경 리스크 관리', '에너지 비용 절감', 'ESG 경영 강화']
  },
  {
    icon: 'ri-shield-check-line',
    code: 'ISO 45001',
    title: '안전보건경영시스템',
    description: '중대재해처벌법 대응 및 안전한 사업장 조성으로 근로자의 안전을 보장합니다.',
    shortDesc: '중대재해법 대응 및 안전한 사업장 조성',
    benefits: ['중대재해 예방', '산재율 감소', '법적 리스크 최소화']
  },
  {
    icon: 'ri-lock-line',
    code: 'ISO 27001',
    title: '정보보안경영시스템',
    description: '기업 데이터 및 정보 자산 보호 체계로 사이버 위협으로부터 안전하게 보호합니다.',
    shortDesc: '정보 자산 보호로 사이버 위협 대응',
    benefits: ['정보 유출 방지', '고객 신뢰 확보', '보안 사고 대응']
  },
  {
    icon: 'ri-heart-pulse-line',
    code: 'ISO 13485',
    title: '의료기기 품질경영',
    description: '의료기기 제조 품질 관리로 글로벌 시장 진출을 위한 필수 인증입니다.',
    shortDesc: '의료기기 글로벌 시장 진출 필수 인증',
    benefits: ['해외 수출 필수', '의료기기 신뢰성', '규제 준수']
  }
];

export default function ISOCertification() {
  return (
    <section id="iso-certification" className="py-16 md:py-24 px-4 md:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <p className="text-teal-600 text-xs md:text-sm font-semibold uppercase tracking-wider mb-2 md:mb-3">
            ISO Certification
          </p>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
            ISO 인증
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            <span className="hidden md:block">글로벌 시장의 표준 규격을 통해 기업의 신뢰성과 안전 시스템을 구축합니다</span>
            <span className="md:hidden">글로벌 표준으로 기업 신뢰성 구축</span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-5 md:p-8 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-100 cursor-pointer group"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4 md:mb-6 group-hover:bg-teal-500 transition-colors">
                <i className={`${cert.icon} text-2xl md:text-3xl text-teal-600 group-hover:text-white transition-colors`}></i>
              </div>
              
              <div className="mb-3 md:mb-4">
                <span className="inline-block px-2.5 py-0.5 md:px-3 md:py-1 bg-teal-600 text-white text-xs md:text-sm font-bold rounded-md">
                  {cert.code}
                </span>
              </div>
              
              <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-2 md:mb-4">{cert.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-4 md:mb-6 text-sm md:text-base">
                <span className="hidden md:block">{cert.description}</span>
                <span className="md:hidden">{cert.shortDesc}</span>
              </p>
              
              <div className="space-y-1.5 md:space-y-2 mb-4 md:mb-6">
                {cert.benefits.map((benefit, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <i className="ri-check-line text-teal-600 text-sm md:text-base"></i>
                    <span className="text-xs md:text-sm text-gray-700">{benefit}</span>
                  </div>
                ))}
              </div>

              <a
                href="#contact"
                className="text-teal-600 font-semibold inline-flex items-center gap-2 cursor-pointer hover:gap-3 transition-all whitespace-nowrap text-sm md:text-base"
              >
                인증 문의하기
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-16 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-xl md:rounded-2xl p-6 md:p-10 border border-teal-100">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6 text-center md:text-left">
            <div>
              <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-1 md:mb-2">
                ISO 인증이 필요하신가요?
              </h3>
              <p className="text-gray-700 text-sm md:text-base">
                <span className="hidden md:inline">전문 컨설턴트가 귀사에 최적화된 인증 프로세스를 안내해드립니다.</span>
                <span className="md:hidden">전문가가 최적의 인증을 안내해드립니다.</span>
              </p>
            </div>
            <a
              href="#contact"
              className="w-full md:w-auto px-6 py-3 md:px-8 md:py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2 text-sm md:text-base"
            >
              무료 상담 신청
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
